module.exports = __webpack_public_path__ + "static/media/avatar.bbc9d3ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar.png
// module id = 132
// module chunks = 0